import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { RegisteredService } from '@core/auth/services/registered.service';
import { UserService } from '@accounts/user/services/user.service';
import { Observable } from 'rxjs/internal/Observable';
import { UserBaseModel } from '@core/api';
import { AuthService } from '@core/auth/services';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { ConfirmationDialogService } from '@ui/confirmation-dialog';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'user-personal-data',
  templateUrl: './user-personal-data.component.html',
  styleUrls: ['./user-personal-data.component.scss']
})
export class UserPersonalDataComponent{

  edit = false;

  get user() {
    return this.userService.user;
  }

  constructor(
    private route: ActivatedRoute,
    private registeredService: RegisteredService,
    private userService: UserService,
    private confirmationDialogService: ConfirmationDialogService,
    private authService: AuthService,
    private i18n: I18n,
    private router: Router,
  ) { }

  get registered(): boolean {
    return !!this.registeredService.value;
  }

  get loadingFullUserData(): Observable<boolean> {
    return this.userService.loadingFullUserData;
  }

  openPersonalDataDialog() {
    this.userService.informationDataDialog();
  }

  editPersonalData() {
    this.edit = true;
  }

  onChanged(userModel: UserBaseModel) {

    this.userService.updateUser(userModel).subscribe(res => {
      this.userService.user = res;
      this.edit = false;
    },
      err => { 
        this.edit = false; 
        console.log(err);
      }
    )
  }

  logout() {
    this.confirmationDialogService.confirm({
      cancelBtnText: this.i18n('Отмена'),
      confirmBtnText: this.i18n('Выйти'),
      message: this.i18n('Вы действительно хотите выйти?'),
      title: this.i18n('Выход')
    })
      .then(() => {
        this.authService.logout()
          .pipe(finalize(() => {
            this.router.navigate([environment.loginUrl]);
          }))
          .subscribe();
      })
      .catch(() => { });
  }
}
